module.exports = __webpack_public_path__ + "static/media/ChronicleSSm-Book_Web.ac685b4d.woff";